import React from "react";

const LanguageContext = React.createContext({
  language: "",
  setLanguage: (lang: string) => {},
});

export default LanguageContext;
